import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/lib/registerServiceWorker";

// ------------------------------------------------------------------
// Fix: recharts <ResponsiveContainer> can throw benign "ResizeObserver
// loop" errors. In CRA dev these trigger a full-screen error overlay that
// makes the page look frozen / non-scrollable / unresponsive (seen when
// opening the Orders, Ads & Analytics dashboard tabs).
// 1) Defer ResizeObserver callbacks via rAF to avoid the loop-limit error.
// 2) Swallow the benign error so the dev overlay never shows.
// ------------------------------------------------------------------
if (typeof window !== "undefined" && window.ResizeObserver) {
  const NativeResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class extends NativeResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
}

const RO_ERR = "ResizeObserver loop";
const hideOverlay = () => {
  const overlay = document.querySelector("#webpack-dev-server-client-overlay");
  if (overlay) overlay.remove();
};
window.addEventListener("error", (e) => {
  if (e.message && e.message.includes(RO_ERR)) {
    e.stopImmediatePropagation();
    e.preventDefault();
    hideOverlay();
  }
});
window.addEventListener("unhandledrejection", (e) => {
  if (e.reason && String(e.reason.message || e.reason).includes(RO_ERR)) {
    e.stopImmediatePropagation();
    e.preventDefault();
    hideOverlay();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

registerServiceWorker();
